import { useLocation, useParams } from '@xing-com/crate-core-router';
import { ErrorContextProvider } from '@xing-com/crate-entity-pages-common';
import { SubpageContainer } from '@xing-com/crate-entity-pages-subpage';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { ContactsDetail } from './contacts-detail';

export default class ArticleViewer implements Xinglet {
  public getComponent() {
    return (): JSX.Element => {
      const { slug, param } = useParams();
      const location = useLocation();

      const isWebview = /^\/pages\/webview/.test(location.pathname);

      return (
        <ErrorContextProvider>
          <SubpageContainer
            pageSlug={slug}
            pageType="contacts"
            param={param}
            isWebview={isWebview}
          >
            <ContactsDetail />
          </SubpageContainer>
        </ErrorContextProvider>
      );
    };
  }
}
